<!-- main app container -->

<ngx-loading-bar [includeSpinner]='false' height='3px' color="#FF4961"></ngx-loading-bar>
<!-- <app-alert></app-alert> -->
<router-outlet *ngIf="showContent"></router-outlet>

<!-- credits -->
